import { render, staticRenderFns } from "./OtpConfirmation.vue?vue&type=template&id=4b9f2a3e&"
import script from "./OtpConfirmation.vue?vue&type=script&lang=js&"
export * from "./OtpConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports